import config from "lib/config";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";

import { XGrid, useGridApiRef } from "@material-ui/x-grid";

import { Menu, Paper, MenuItem } from "@material-ui/core";

import TuneOutlinedIcon from "@material-ui/icons/TuneOutlined";

import "./DataGrid.scss";

import { LicenseInfo } from "@material-ui/x-grid";
LicenseInfo.setLicenseKey(config["x_grid_license_key"]);

const useStyles = makeStyles((theme) => ({
  actionsContainer: {
    display: "flex",
  },
  paper: {
    boxShadow: "none",
  },
  table: {
    height: 600,
    width: "100%",
    border: "none",
    minHeight: 250,
    backgroundColor: theme.palette.background.default,
    "& .MuiDataGrid-toolbar": {
      justifyContent: "space-between",
    },
    "& .MuiDataGrid-main": {
      borderRadius: 5,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
    },
  },
  textField: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
  noRowsText: {
    alignItems: "center",
    justifyContent: "center",
  },
}));

export default function DataTable(props) {
  const classes = useStyles();

  const [page, setPage] = useState(0);
  const [contextMenu, setContextMenu] = useState({});
  const apiRef = useGridApiRef();

  useEffect(() => {
    setPage(0);
  }, [props.data, setPage]);

  useEffect(() => {
    const handleRowClick = (params, event, details) => {
      props.onColumnOrderChange(
        details.api.getVisibleColumns().map((obj) => obj.field)
      );
    };

    // The `subscribeEvent` method will automatically unsubscribe in the cleanup function of the `useEffect`.
    return apiRef.current.subscribeEvent("columnHeaderDragEnd", handleRowClick);
  }, [apiRef]);

  const handleClick = (gridCellParams, event) => {
    if (props.contextMenuItems) {
      setContextMenu({
        anchorEl: event.currentTarget,
        model: gridCellParams.row,
        fieldName: gridCellParams.field,
      });
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const menuClick = (menuItem) => {
    menuItem.onClick(contextMenu);
    setContextMenu({});
  };

  const getRowId = (row) => {
    return row.id || props.data.indexOf(row);
  };

  return (
    <div>
      <Paper
        className={classes.paper}
        onKeyDownCapture={(e) => {
          if (e.key === "Backspace" || e.key === "Delete") {
            e.stopPropagation();
          }
        }}
        datacy={"reportDataTable"}
      >
        <XGrid
          apiRef={apiRef}
          disableScrollLock={false}
          disableColumnMenu={true}
          disableSelectionOnClick={true}
          pagination
          pageSize={20}
          page={page}
          autoHeight={true}
          className={classes.table}
          onPageChange={handlePageChange}
          //checkboxSelection
          getRowId={getRowId}
          onCellClick={handleClick}
          columns={props.isFetching ? [] : props.columns}
          rows={props.data}
          loading={props.isFetching}
          rowHeight={38}
          icons={{
            OpenFilterButtonIcon: TuneOutlinedIcon,
          }}
        />
        <Menu
          id="context-menu"
          anchorEl={contextMenu.anchorEl}
          keepMounted
          open={Boolean(contextMenu.anchorEl)}
          onClose={() => setContextMenu({})}
          disableScrollLock={true}
        >
          {props.contextMenuItems &&
            props.contextMenuItems.map((menuItem) => (
              <MenuItem
                key={menuItem.text}
                disabled={
                  menuItem.isDisabled && menuItem.isDisabled(contextMenu)
                }
                onClick={() => menuClick(menuItem)}
              >
                {menuItem.text}
              </MenuItem>
            ))}
        </Menu>
      </Paper>
    </div>
  );
}

DataTable.propTypes = {
  isFetching: PropTypes.bool,
};

DataTable.defaultProps = {
  data: [],
  columns: [],
  isFetching: false,
};
